import { useMutation, useQuery } from "@apollo/client";
import React, { useState, useEffect } from "react";
import sfdaMedicine from "../../../gql/sfdaMedicine";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../components/Pagination";
import { useTranslation } from "react-i18next";
import TableSkeletonLoader from "../../../common/TableLoading";
import AppTable from "../../../shared/AppTable";
import AppButton from "../../../shared/AppButton";
import AddIcon from "@mui/icons-material/Add";
import SearchInput from "../../../components/SearchInput";
import ConformationModal from "../../../components/ConformationModal";
import CustomFilterInput from "../../../shared/CustomFilterInput";
import { FaFilter, FaUndo } from "react-icons/fa";

function SfdaMedicineList() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [limit, setLimit] = useState(15);
  const [pageNo, setPageNo] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [search, setSearch] = useState("");
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);

  const { loading, error, data, refetch } = useQuery(
    sfdaMedicine.GET_SFDA_MEDICINES,
    {
      variables: { page: pageNo, limit: limit, search: search },
      fetchPolicy: "network-only",
    }
  );

  const [deleteMedicine] = useMutation(sfdaMedicine.DELETE_SFDA_MEDICINE, {
    onCompleted: () => {
      toast.success(t("Successfully Deleted!"));
      refetch();
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  useEffect(() => {
    if (error) {
      toast.error(error.message);
    }
  }, [error]);

  const onPageChange = (currentPage) => {
    setPageNo(currentPage);
  };

  const onClickDelete = (item) => {
    setCurrentItem(item);
    setShowDeleteAlert(true);
  };

  const handleDelete = () => {
    deleteMedicine({ variables: { id: currentItem.id } });
    setShowDeleteAlert(false);
  };

  const onClickEdit = (item) => {
    navigate("/super-admin/sfda-medicine/form", { state: { item } });
  };

  const columns = [
    {
      header: t("Register Number"),
      field: "registerNumber",
      render: (row) => <span className="font-medium">{row.registerNumber}</span>,
    },
    { header: t("Trade Name"), field: "tradeName" },
    { header: t("Scientific Name"), field: "scientificName" },
    { header: t("Marketing Company"), field: "marketingCompany" },
    { header: t("Public Price"), field: "publicPrice" },
    // {
    //   header: t("Status"),
    //   render: (row) => (
    //     <span
    //       className={`px-2 py-1 rounded-full text-xs font-semibold ${row.marketingStatus === "Active"
    //         ? "bg-green-100 text-green-800"
    //         : "bg-gray-100 text-gray-800"
    //         }`}
    //     >
    //       {t(row.marketingStatus)}
    //     </span>
    //   ),
    // },
  ];

  return (
    <div className="superGit_container !p-0">
      <div className="flex justify-between items-start flex-col md:flex-row gap-2 mb-2">
        <div className="w-full sm:w-[calc(100%-150px)]">
          <span className="font-semibold text-black/70 text-lg ">
            {t("SFDA MEDICINES")}
            <span className=" text-lg ml-1">
              ({data?.getSfdaMedicines?.pageInfo?.totalCount || 0}{" "}
              <span className="text-xs font-bold italic">{t("Entries")}</span>)
            </span>
          </span>
        </div>
        <div className="w-full flex gap-1.5 flex-col md:flex-row justify-end">
          <AppButton
            label={t("Create Medicine")}
            startIcon={<AddIcon />}
            onClick={() => navigate("/super-admin/sfda-medicine/form")}
          />
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg p-2 mb-2">
        <div className="flex items-center">
          <div className="w-full flex flex-col sm:flex-row gap-x-1.5 gap-y-1.5 justify-end">
            <div className="w-[200px]">
              <CustomFilterInput
                label={t("Search Medicines")}
                name="search"
                placeholder={t("Search by name, register number...")}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="flex gap-2 mt-[19px]">
              <AppButton
                // label={t("Reset")}
                variant="reset"
                className="!bg-slate-200"
                onClick={() => {
                  setSearchTerm("");
                  setSearch("");
                  setPageNo(1);
                }}
                startIcon={<FaUndo className="!text-[12px] " />}
              />
              <AppButton
                // label={t("Apply Filter")}
                onClick={() => {
                  setSearch(searchTerm);
                  setPageNo(1);
                }}
                startIcon={<FaFilter className="!text-[12px]" />}
              />
            </div>
          </div>
        </div>
      </div>

      <AppTable
        columns={columns}
        data={data?.getSfdaMedicines?.medicines}
        loading={loading}
        onEdit={onClickEdit}
        // onDelete={onClickDelete}
        LoaderComponent={<TableSkeletonLoader columnCount={6} rowCount={10} />}
      />

      <div className="mt-4">
        <Pagination
          currentPage={pageNo}
          totalPages={data?.getSfdaMedicines?.pageInfo?.totalPages || 1}
          onPageChange={onPageChange}
        />
      </div>

      <ConformationModal
        open={showDeleteAlert}
        setOpen={setShowDeleteAlert}
        onDelete={handleDelete}
      />
    </div>
  );
}

export default SfdaMedicineList;
